// extracted by mini-css-extract-plugin
module.exports = {"discountInfo":"PaymentsPromoCodeDeactivateForm__discountInfo","discountImage":"PaymentsPromoCodeDeactivateForm__discountImage"};